<template>
  <div class="code-card" @click="$emit('select', code)">
    <div class="card-icon">{{ code.icon }}</div>
    <div class="card-body">
      <h3 class="card-title">{{ code.name }}</h3>
      <p class="card-desc">{{ code.description }}</p>
    </div>
    <div class="card-footer">
      <span class="card-category">{{ code.category }}</span>
      <span v-if="code.params && code.params.length" class="card-params">
        ⚙️ {{ code.params.length }} params
      </span>
      <span class="card-lang" :class="'lang-' + (code.lang || 'en')">
        {{ (code.lang || 'en') === 'ko' ? '🇰🇷' : ((code.lang || 'en') === 'multi' ? '🌐' : '🇺🇸') }}
      </span>
    </div>
    <div class="card-stats">
      <span class="stat-item">👁️ {{ formatCount(code.views || 0) }}</span>
      <span class="stat-item">📥 {{ formatCount(code.downloads || 0) }}</span>
      <span v-if="code.author" class="card-author">👤 {{ code.author }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CodeCard',
  props: {
    code: { type: Object, required: true },
  },
  emits: ['select'],
  methods: {
    formatCount(n) {
      if (n >= 1000) return (n / 1000).toFixed(1) + 'k'
      return n
    },
  },
}
</script>

<style scoped>
.code-card {
  background: var(--card-bg);
  border: 1px solid var(--surface2);
  border-radius: var(--radius);
  padding: 28px;
  cursor: pointer;
  transition: all var(--transition);
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  overflow: hidden;
}

.code-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--green), var(--teal));
  opacity: 0;
  transition: opacity var(--transition);
}

.code-card:hover {
  transform: translateY(-4px);
  border-color: var(--green);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35), 0 0 30px rgba(166, 227, 161, 0.15);
}
.code-card:hover::before { opacity: 1; }

.card-icon { font-size: 36px; line-height: 1; }
.card-body { flex: 1; }
.card-title {
  font-size: 17px; font-weight: 700;
  color: var(--text); margin-bottom: 8px;
}
.card-desc {
  font-size: 13px; color: var(--subtext0); line-height: 1.6;
  display: -webkit-box; -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; overflow: hidden;
}
.card-footer {
  display: flex; align-items: center; gap: 10px; flex-wrap: wrap;
}
.card-category {
  font-size: 11px; color: var(--green);
  background: rgba(166, 227, 161, 0.1);
  padding: 4px 10px; border-radius: 6px;
}
.card-params {
  font-size: 11px; color: var(--yellow);
  background: rgba(249, 226, 175, 0.1);
  padding: 4px 10px; border-radius: 6px;
}
.card-stats {
  display: flex; align-items: center; gap: 14px;
  padding-top: 8px; border-top: 1px solid var(--surface1);
}
.stat-item {
  display: inline-flex; align-items: center; gap: 4px;
  font-size: 12px; color: var(--overlay1); cursor: default;
}
.card-lang {
  font-size: 12px; padding: 2px 6px; border-radius: 6px;
}
.card-author {
  font-size: 11px;
  color: var(--overlay1);
  background: rgba(127, 132, 156, 0.1);
  padding: 3px 8px;
  border-radius: 6px;
  margin-left: auto;
}
</style>
